import gql from 'graphql-tag';

const UPDATE_HOMEOWNER_NOTE = gql` 
  mutation updateHomeownerNote($input: HomeownerNoteUpdateInput) {
    updateHomeownerNote(input: $input) {
      message
      code
      data
    }
  }
`;

export default UPDATE_HOMEOWNER_NOTE;